<template>
<div>
<ContentHeader title="Soru Listesi Koşulu"  url="Questionlistconditions" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">



<div class="mt-4">
<span class="p-float-label mb-4 mt-0" >
 <InputText 
 id="reminder" 
 type="text" 
 v-model="reminder" 
 class="w-full p-inputtext-sm" 
 @input="watchChange" 
 />
 <label for="reminder" >Koşul notu</label>
</span>
<h4 class="text-primary">Koşullar</h4>
<Questionlistconditionline 
v-for="condition in conditions" 
:inputfields="inputfields" 
:questionlists="questionlists" 
:customattributes="customattributes" 
:conditiondata="condition" 
:nonconformitytypes="nonconformitytypes" 
:customcalculations="customcalculations"
:classes="classes" 
@conditionConcluded="conditionConcluded" 
@removeCondition="removeCondition"
></Questionlistconditionline>

<template v-if="outcomes.length">
	
<hr>
<h4 class="text-primary">Eylemler</h4>
<Questionlistconditionoutcomeline 
v-for="outcome in outcomes" 
:inputfields="inputfields" 
:inputfieldsections="inputfieldsections" 
:customattributes="customattributes"  
:customcalculations="customcalculations"
:outcomedata="outcome"  
@outcomeConcluded="outcomeConcluded" 
@removeOutcome="removeOutcome"
></Questionlistconditionoutcomeline>
</template>





<div class="flex align-items-center justify-content-end mb-6 mt-4" v-if="ready_to_save">
<hr>
<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting"  @click="submit"></Button>
</div>

</div>

</template>

</div>
</template>

<script>
const condition_obj= {
	id:null,
	type:null,//inputfield,customattribute
    inputfield_id:null,
    inputfieldcolumn_id:null,
    customattribute_id:null,
    customcalculation_id:null,
    nonconformitytype_id:null,
    class_id:null,
	operator:null,//and, or
	numerical_val:null,
    comparison_type:null,
    comparison_inputfield_id:null,
    comparison_inputfield_column_id:null,
    comparison_calculation_id:null,
	text_val:null,
	execution_type:null,//equal_to,not_equal_to,less_than,greater_than,includes,does_not_include,
	
}

const outcome_obj= {
	id:null,
	type:null,//inputfield,customattribute,section,
    inputfield_id:null,
    inputfieldcolumn_id:null,
    inputfieldsection_id:null,
	customattribute_id:null,
    effecting_item:null,////inputfield,customattribute,section,
    effecting_inputfield_id:null,
    effecting_inputfieldcolumn_id:null,
    effecting_inputfieldsection_id:null,
    effecting_customattribute_id:null,
	operator:null,//and, or
	numerical_val:null,
	text_val:null,
    comparison_type:null,
    comparison_inputfield_id:null,
    comparison_inputfield_column_id:null,
    comparison_calculation_id:null,
    execution_type:null,//change_value,change_points
    column_execution_type:null,//change_value,change_points
	
}

import Questionlistconditionline from "./Questionlistconditionline"
import Questionlistconditionoutcomeline from "./Questionlistconditionoutcomeline"

export default {

  name: 'Questionlistcondition',
  components:{Questionlistconditionline,Questionlistconditionoutcomeline},
  data () {
    return {
    	loading:true,
    	inputfields:[],
        questionlists:[],
        nonconformitytypes:[],
        classes:[],
        customcalculations:[],
    	customattributes:[],
        inputfieldsections:[],
    	conditions:[],
    	outcomes:[],
    	ready_to_save:false,
        reminder:null,
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    watchChange(data)
    {
        if(data.target._value && data.target._value.length>250)
        {
            console.log(data.target._value.length)
            console.log(this.reminder.length>250)
            this.reminder = data.target._value.slice(0, 250);
        }
    },
  	async getData()
    {
     this.loading = await true
      let inputfields = await this.generalApiGetWithoutLoader("questionlists/inputfields/"+this.$route.params.id)
      console.log("inputfields")
      console.log(inputfields)
      let questionlists = await this.generalApiGetWithoutLoader("brand/brand_questionlists/"+this.$store.state.questionlists.questionlist.brand_id)
      let nonconformitytypes = await this.generalApiGetWithoutLoader("questionlistnonconformitytypes/"+this.$route.params.id)
      this.classes = await this.generalApiGetWithoutLoader("inputfieldclasses/"+this.$route.params.id)
      let inputfieldsections = await this.generalApiGetWithoutLoader("questionlists/inputfieldsections/"+this.$route.params.id)
      let customattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.questionlists.questionlist.brand_id)   
      let questionlistoptions = await this.generalApiGetWithoutLoader("questionlistoptions/"+this.$route.params.id)      
      await console.log(customattributes)
      let same_question_pattern = false
      if(this.$store.state.questionlists.questionlist.type=="same_question_pattern")
      {
        same_question_pattern = true
      }

      for(let item of inputfields)
      {
      	if(item.name.length>60)
        {
            item.name = item.name.substring(0, 60)+"...";
        }
        if(item.columns.length)
        {
            item.columns = item.columns.filter((element)=>{return element.type!=="readonly"})
        }
        if(same_question_pattern)
        {
            item.options = questionlistoptions
        }
      }
      this.customcalculations = await this.generalApiGetWithoutLoader("questionlistsametypecalculations/"+this.$route.params.id)
      console.log("customcalculations")
      console.log(this.customcalculations)
      
      this.inputfields = await inputfields
      this.inputfieldsections = await inputfieldsections
      this.customattributes = await customattributes
      nonconformitytypes.unshift({
        name:"Hepsi",
        id:"all"
      })
      this.nonconformitytypes = await nonconformitytypes

      if(this.$route.params.condition_id)
      {
      	let item = await this.generalApiGetWithoutLoader("questionlists_condition/"+this.$route.params.condition_id)
      	let conditions = await JSON.parse(item.conditions)
	  	let outcome = await JSON.parse(item.outcome)
	  	this.conditions = await conditions
        this.outcomes = await outcome
        this.reminder = await item.reminder
	  	this.ready_to_save = true

      }
      else
      {
      	await this.addNewCondition()
      }
      
      console.log(this.customattributes)
      this.loading = await false
    },
    addNewCondition()
    {
    	let new_condition =  this.sanitizeArray(condition_obj)
        new_condition.id =  Math.floor(Date.now() / 1000)
        this.conditions.push(new_condition)
    },
    addNewOutcome()
    {
    	let new_outcome =  this.sanitizeArray(outcome_obj)
        new_outcome.id =  Math.floor(Date.now() / 1000)
        this.outcomes.push(new_outcome)
    },
    conditionConcluded(data)
    {
    	console.log(data)
    	let ind = this.conditions.findIndex((item)=>{return item.id == data.id})
    	let first = this.conditions[0]
    	if(first && first.operator !== data.operator && data.operator !=="execute")
    	{
    		this.showMessage("error","Koşuldaki her mantık operatörünün aynı olması gerekli",first.operator+" operatörü ile devam edin")
    		return false
    	}
    	this.conditions[ind] = data
    	
    	if(data.operator !=="execute")
    	{

    		this.addNewCondition()
    	}
    	else
    	{
    		if(!this.outcomes.length)
    		{
    			this.addNewOutcome()
    		}
    		
    	}
    	console.log(this.conditions)
    	
    },
    async removeCondition(data)
    {
    	await console.log("removeCondition")
    	await console.log(data)
    	let conditions = await this.conditions.filter((item)=>{return item.id !== data.id})
    	await console.log(conditions)
    	this.conditions = await []
    	//return false
    	if(conditions.length)
    	{
    		this.conditions = await conditions
    		//let last = await this.conditions[this.conditions.length-1]
    		//last.operator = await "execute"
    	}
    	else
    	{
    		await this.addNewCondition()
    	}
    	await console.log(this.conditions)    	
    },

    outcomeConcluded(data)
    {
    	console.log(data)
    	let ind = this.outcomes.findIndex((item)=>{return item.id == data.id})
    	this.outcomes[ind] = data
    	
    	if(data.operator !=="execute")
    	{
    		this.addNewOutcome()
    	}
    	else
    	{
    		
    		this.ready_to_save = true
    		
    	}
    	console.log(this.outcomes)
    	
    },
    async removeOutcome(data)
    {
    	await console.log("removeOutcome")
    	await console.log(data)
    	let outcomes = await this.outcomes.filter((item)=>{return item.id !== data.id})
    	await console.log(outcomes)
    	this.outcomes = await []
    	//return false
    	if(outcomes.length)
    	{
    		this.outcomes = await outcomes
    	}
    	else
    	{
    		await this.addNewOutcome()
    		this.ready_to_save = false
    	}
    	await console.log(this.outcomes)    	
    },
    submit()
    {
    	let formdata = new FormData()
    	formdata.append('questionlist_id', this.$route.params.id);
        formdata.append('conditions', JSON.stringify(this.conditions));
        formdata.append('outcomes', JSON.stringify(this.outcomes));
        if(this.reminder)
        {
            formdata.append('reminder', this.reminder);
        }
        
        if(this.$route.params.condition_id)
        {
            this.generalSubmission(formdata,"questionlists_condition/"+this.$route.params.condition_id,this.afterSubmit)
        }
        else
        {
            this.generalSubmission(formdata,"questionlists_condition",this.afterSubmit)
        }
    },
    afterSubmit(response)
    {
    	console.log(response.data)
    	this.$router.push({ name: 'Questionlistconditions'})
    }


  }
}
</script>

<style lang="css" scoped>
</style>